<!-- 抄表数据总览 -->
<template>
  <div class="reading-approval">
    <!-- 内容区域 -->
    <div class="content-wrapper">
      <!-- 统计区块 -->
      <div class="dashboard">
        <div class="dashboard-item">
          <!-- 饼图：抄表状态统计 -->
          <div ref="pieChart" style="width: 100%; height: 260px"></div>
        </div>
      </div>
      <a-form layout="inline" class="filter-form">
        <a-form-item label="用户：">
          <UserSelect v-model="filters.userCode" @change="onUserSelectChange" :show-debug="true" />
        </a-form-item>
        <a-form-item label="抄表状态：">
          <a-select v-model="filters.status" style="width: 150px" @change="onSearch" allow-clear>
            <a-select-option value="">全部</a-select-option>
            <a-select-option value="0">未抄表</a-select-option>
            <a-select-option value="1">已抄表</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="用水性质：">
          <a-select v-model="filters.waterUsageType" style="width: 150px">
            <a-select-option :value="1">居民用水</a-select-option>
            <a-select-option :value="2">非居民用水</a-select-option>
            <a-select-option :value="3">特种用水</a-select-option>
            <a-select-option :value="4">工业用水</a-select-option>
            <a-select-option :value="5">混合用水</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item>
          <a-button type="primary" @click="onSearch">查询</a-button>
        </a-form-item>
        <a-form-item>
          <a-button @click="onReset2">重置</a-button>
        </a-form-item>
      </a-form>
      <!-- 数据表格 -->
      <a-table
        :columns="columns"
        :data-source="tableData"
        row-key="userCode"
        :pagination="pagination"
        @change="handleTableChange"
        bordered
        class="reading-table"
      >
        <template slot="readingStatus" slot-scope="text">
          <a-tag :color="getStatusColor(text)" class="status-tag">
            {{ { 0: '未抄表', 1: '已抄表' }[text] || text }}
          </a-tag>
        </template>
        <template slot="action" slot-scope="record">
          <a v-if="record.readingStatus !== 0 && record.imageUrl" @click="viewImage(record.imageUrl)">查看图片</a>
        </template>
      </a-table>

      <!-- 图片预览弹窗 -->
      <a-modal
        v-model="imagePreviewVisible"
        title="图片预览"
        :footer="null"
        :width="800"
        :centered="true"
        @cancel="imagePreviewVisible = false"
      >
        <div class="image-preview-container">
          <img
            v-if="currentImageUrl"
            :src="currentImageUrl"
            alt="抄表图片"
            class="preview-image"
            @error="handleImageError"
          />
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import UserSelect from './components/UserSelect.vue'

export default {
  name: 'TaskProgress',
  components: {
    UserSelect,
  },
  props: {
    taskId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      readerId: '',
      filters: {
        userCode: '',
        status: '',
        userName: '',
        waterUsageType: '',
      },
      userLoading: false,
      readerList: [],
      pieOption: {
        title: {
          text: '抄表状态统计',
          left: 'left',
          top: 0,
          textStyle: {
            fontSize: 16,
          },
        },
        tooltip: { trigger: 'item' },
        legend: { bottom: 0 },
        color: ['#f5222d', '#faad14'], // 未抄表-红色, 已抄表-橙色
        series: [
          {
            name: '抄表状态',
            type: 'pie',
            radius: '70%',
            data: [],
            label: {
              formatter: '{b}: {d}%',
            },
          },
        ],
      },
      columns: [
        { title: '用户编码', dataIndex: 'userCode', key: 'userCode', width: 110 },
        {
          title: '用户名',
          dataIndex: 'userName',
          key: 'userName',
          width: 110,
          ellipsis: true,
          customRender: (text) => {
            return {
              children: text,
              props: {
                title: text, // 添加title属性用于tooltip
              },
            }
          },
        },
        {
          title: '水表编号',
          dataIndex: 'meterNumber',
          key: 'meterNumber',
          width: 120,
          ellipsis: true,
          customRender: (text) => {
            return {
              children: text,
              props: {
                title: text, // 添加title属性用于tooltip
              },
            }
          },
        },
        {
          title: '用户地址',
          dataIndex: 'address',
          key: 'address',
          width: 180,
          ellipsis: true,
          customRender: (text) => {
            return {
              children: text,
              props: {
                title: text, // 添加title属性用于tooltip
              },
            }
          },
        },
        {
          title: '用水性质',
          dataIndex: 'waterUsageType',
          key: 'waterUsageType',
          width: 120,
          customRender: (text) => {
            const map = { 1: '居民用水', 2: '非居民用水', 3: '特种用水', 4: '工业用水', 5: '混合用水' }
            return map[text] || text
          },
        },
        { title: '上期行至', dataIndex: 'previousReading', key: 'previousReading', width: 80 },
        { title: '上期用水量(m³)', dataIndex: 'previousUsage', key: 'previousUsage', width: 120 },
        {
          title: '上期抄表时间',
          dataIndex: 'previousReadingTime',
          key: 'previousReadingTime',
          width: 140,
          ellipsis: true,
          customRender: (text) => {
            return {
              children: text,
              props: {
                title: text, // 添加title属性用于tooltip
              },
            }
          },
        },
        { title: '本期行至', dataIndex: 'currentReading', key: 'currentReading', width: 100 },
        { title: '本期用水量(m³)', dataIndex: 'currentUsage', key: 'currentUsage', width: 140 },
        { title: '补充水量', dataIndex: 'supplementaryWaterAmount', key: 'supplementaryWaterAmount', width: 140 },
        {
          title: '抄表员',
          dataIndex: 'readerName',
          key: 'readerName',
          width: 90,
          ellipsis: true,
          customRender: (text) => {
            return {
              children: text,
              props: {
                title: text, // 添加title属性用于tooltip
              },
            }
          },
        },
        {
          title: '抄表时间',
          dataIndex: 'currentReadingTime',
          key: 'currentReadingTime',
          width: 140,
          ellipsis: true,
          customRender: (text) => {
            return {
              children: text,
              props: {
                title: text, // 添加title属性用于tooltip
              },
            }
          },
        },
        {
          title: '抄表状态',
          dataIndex: 'readingStatus',
          key: 'readingStatus',
          width: 120,
          align: 'center',
          ellipsis: false,
          scopedSlots: { customRender: 'readingStatus' },
        },
        { title: '图片', key: 'action', width: 120, scopedSlots: { customRender: 'action' } },
      ],
      tableData: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
      },
      pieChartInstance: null,
      statsLoading: false,
      waterUsageLoading: false,
      waterUsageParams: {
        startDate: '',
        endDate: '',
        readerId: '',
      },
      // 图片预览相关
      imagePreviewVisible: false,
      currentImageUrl: '',
    }
  },
  created() {
    console.log('TaskProgress - taskId:', this.taskId)

    if (!this.taskId) {
      this.$message.error('缺少任务ID参数')
      this.$emit('close')
      return
    }

    this.getReaderList()
    this.fetchTableData()
    this.fetchStatsPie()
  },
  mounted() {
    this.initCharts()
    // 监听窗口大小变化，重绘图表
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    if (this.pieChartInstance) this.pieChartInstance.dispose()
    // 移除事件监听
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    // 供外部在弹窗完全打开后强制触发尺寸计算
    forceResize() {
      this.$nextTick(() => {
        if (this.pieChartInstance) {
          this.pieChartInstance.resize()
        }
      })
    },
    async fetchStatsPie() {
      try {
        const { data: pieResp } = await this.$http.get('/meter-manager/meter_tasks/stats/' + this.taskId)
        const pieData = pieResp || {}
        this.pieOption.series[0].data = [
          { value: Number(pieData.unreadCount) || 0, name: '未抄表' },
          { value: Number(pieData.alreadyReadCount) || 0, name: '已抄表' },
        ]
        if (this.pieChartInstance) {
          this.pieChartInstance.setOption(this.pieOption)
        }
      } catch (e) {
        console.error('fetchStatsPie error:', e)
        this.$message.error('获取抄表状态统计失败')
      }
    },
    initCharts() {
      this.$nextTick(() => {
        if (this.$refs.pieChart) {
          this.pieChartInstance = echarts.init(this.$refs.pieChart)
          this.pieChartInstance.setOption(this.pieOption)
        }
      })
    },
    handleResize() {
      if (this.pieChartInstance) {
        this.pieChartInstance.resize()
      }
    },

    async fetchTableData() {
      const params = {
        limit: this.pagination.pageSize,
        page: this.pagination.current,
        readingStatus: this.filters.status,
        userCode: this.filters.userCode,
        userName: this.filters.userName,
        waterUsageType: this.filters.waterUsageType,
      }
      try {
        console.log('fetchTableData - taskId:', this.taskId)
        console.log('fetchTableData - params:', params)

        const { data } = await this.$http.get('/meter-manager/meter_tasks/detail/' + this.taskId, { params })
        console.log('fetchTableData - response:', data)

        this.tableData = data.list || []
        this.pagination.total = Number(data.total) || 0
      } catch (e) {
        console.error('fetchTableData error:', e)
        this.$message.error('获取列表失败')
      }
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.fetchTableData()
    },
    async onSearch() {
      this.pagination.current = 1
      await this.fetchTableData()
    },

    onReset2() {
      this.filters = {
        userCode: '',
        status: '',
        userName: '',
        waterUsageType: '',
      }
      this.pagination.current = 1
      this.fetchTableData()
    },
    statusClass(status) {
      if (status === '未抄表') return 'status-unread'
      if (status === '已抄表') return 'status-pending'
      return ''
    },
    viewImage(url) {
      this.currentImageUrl = url
      this.imagePreviewVisible = true
    },
    handleImageError() {
      this.$message.error('图片加载失败')
      this.imagePreviewVisible = false
    },

    // 用户选择变化处理
    onUserSelectChange(value, user) {
      console.log('用户选择变化:', value, user)
      // 更新用户名称
      if (user) {
        this.filters.userName = user.userName
      } else {
        this.filters.userName = ''
      }
      this.onSearch()
    },

    getReaderList(search = '') {
      this.$http
        .get('/meter-manager/meter_readers/list', { params: { name: search } })
        .then(({ data }) => {
          this.readerList = data || []
        })
        .catch(() => {})
    },
    filterReaderOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    handleClose() {
      this.$emit('close')
    },

    // 获取状态颜色
    getStatusColor(status) {
      const colorMap = {
        0: '#f5222d', // 未抄表 - 红色
        1: '#faad14', // 已抄表 - 橙色
      }
      return colorMap[status] || '#d9d9d9'
    },
  },
  watch: {
    taskId: {
      handler(newTaskId) {
        if (newTaskId) {
          console.log('TaskProgress - taskId changed:', newTaskId)
          this.fetchTableData()
          this.fetchStatsPie()
        }
      },
      immediate: false,
    },
  },
}
</script>

<style scoped>
.reading-approval {
  padding: 0;
  background: #fff;
}
.content-wrapper {
  padding: 24px;
}
.filter-form {
  margin-bottom: 24px;
}
.dashboard {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
}
.dashboard-item {
  background: #fbfbfb;
  border-radius: 4px;
  box-shadow: 0 2px 8px #f0f1f2;
  padding: 16px;
  flex: 1;
  margin-right: 16px;
}
.dashboard-item:last-child {
  margin-right: 0;
}
.progress-board {
  padding: 16px;
  padding-top: 0px;
  background-color: #fff;
  border-radius: 4px;
}
.stats-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
}
.stats-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
.stats-total {
  font-size: 14px;
  color: #666;
}
.stats-item {
  margin-bottom: 20px;
}
.stats-info {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.stats-label {
  font-size: 14px;
  color: #666;
  margin-right: 10px;
}
.stats-value {
  font-size: 20px;
  font-weight: bold;
  margin-right: 4px;
}
.stats-unit {
  font-size: 14px;
  color: #666;
  margin-right: 8px;
}
.stats-percent {
  font-size: 14px;
  color: #999;
}
.primary {
  color: #1890ff;
  font-weight: bold;
}
.danger {
  color: #f5222d;
  font-weight: bold;
}
.warning {
  color: #ffa39e;
  font-weight: bold;
}
.success {
  color: #52c41a;
  font-weight: bold;
}
.reading-table {
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px #f0f1f2;
  margin-bottom: 24px;
}

/* 表格状态列样式 */
.reading-table /deep/ .ant-table-tbody > tr > td {
  vertical-align: middle;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

/* 为有省略号的单元格添加tooltip样式 */
.reading-table /deep/ .ant-table-tbody > tr > td[title] {
  cursor: help;
  position: relative;
}

/* 确保tooltip能够正确显示 */
.reading-table /deep/ .ant-table-tbody > tr > td[title]:hover {
  background-color: #f5f5f5;
}

/* 抄表状态列不显示省略号 */
.reading-table /deep/ .ant-table-tbody > tr > td:nth-child(13) {
  white-space: normal !important;
  text-overflow: unset !important;
  overflow: visible !important;
}

/* 图片预览样式 */
.image-preview-container {
  text-align: center;
  max-height: 70vh;
  overflow: auto;
}

.preview-image {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.reading-table /deep/ .ant-table-thead > tr > th {
  background: #fafafa;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.status-unread {
  color: #f5222d;
}
.status-pending {
  color: #1890ff;
}
.status-readed {
  color: #52c41a;
}

/* 状态标签样式 */
.status-tag {
  min-width: 60px;
  text-align: center;
  font-weight: 500;
  border-radius: 4px;
  color: white !important;
  font-size: 12px;
  padding: 2px 8px;
}
</style>
